import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    // 📍 Google Analytics 4 (gtag.js)
    if (window.gtag) {
      window.gtag("event", "page_view", {
        page_location: window.location.href,
        page_path: location.pathname + location.search,
        // page_title: document.title,
      });
    }

    // 📍 Piwik PRO o Matomo
    // if (window._paq) {
    //   window._paq.push(["setCustomUrl", location.pathname + location.search]);
    //   window._paq.push(["setDocumentTitle", document.title]);
    //   window._paq.push(["trackPageView"]);
    // }
  }, [location]);

  return null;
}
